import { Box } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  '& .TLConatiner': {
    padding: theme.spacing(0, 8),
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(0, 3),
    },
  },
  '& .TLVIconicSectionContainer': {
    marginBottom: theme.spacing(14),
    paddingTop: theme.spacing(12),
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      paddingTop: 0,
    },
  },

  '& .TLVBGImageContainer': {
    position: 'absolute',
    top: 0,
    left: 0,
    height: theme.typography.pxToRem(200),
    right: 0,
    zIndex: 0,
  },
  '& .TLIconicBackground': {
    position: 'absolute',
    top: '-1px',
    left: 0,
    bottom: 0,
    right: 0,
    background: `linear-gradient(to bottom ,${
      theme.palette.common.black
    } 1%, ${alpha(theme.palette.common.black, 0.9)} 2%, ${alpha(
      theme.palette.common.black,
      0.7,
    )} 5%,${alpha(theme.palette.common.black, 0.6)} 10%, ${
      theme.palette.background.default
    }  50%)`,
    zIndex: 1,
  },
  '& .TLIconicContainer': {
    position: 'relative',
    zIndex: 2,
  },
}));

export default StyledBox;
